(() => {
  if (window.ThemeBackInStockFormLoaded) return;
  window.ThemeBackInStockFormLoaded = true;

  const signedUpClass = 'product-form__back-in-stock-fields--signed-up';

  const setFormSignedUp = (form) => {
    const fields = form.querySelector('.product-form__back-in-stock-fields');
    const emailInput = form.querySelector('input[name="contact[email]"]');
    const submitButton = form.querySelector('[data-back-in-stock-submit]');
    const submitText = form.querySelector('[data-back-in-stock-submit-text]');
    const successMessage = form.querySelector('[data-back-in-stock-success]');

    form.dataset.signedUp = 'true';
    form.classList.remove('is-submitting');
    fields?.classList.add(signedUpClass);
    if (emailInput) emailInput.disabled = true;
    if (submitButton) submitButton.disabled = true;
    if (submitText) submitText.textContent = form.dataset.signedUpText;
    successMessage?.classList.remove('hidden');
  };

  const resetForm = (form) => {
    const fields = form.querySelector('.product-form__back-in-stock-fields');
    const emailInput = form.querySelector('input[name="contact[email]"]');
    const submitButton = form.querySelector('[data-back-in-stock-submit]');
    const submitText = form.querySelector('[data-back-in-stock-submit-text]');
    const successMessage = form.querySelector('[data-back-in-stock-success]');

    form.dataset.signedUp = 'false';
    form.classList.remove('is-submitting');
    fields?.classList.remove(signedUpClass);
    if (emailInput) emailInput.disabled = false;
    if (submitButton) submitButton.disabled = false;
    if (submitText) submitText.textContent = form.dataset.submitText;
    successMessage?.classList.add('hidden');
  };

  const initializeForm = (form) => {
    const successMessage = form.querySelector('[data-back-in-stock-success]');
    const hasRenderedSuccess = successMessage && !successMessage.classList.contains('hidden');

    if (form.dataset.signedUp === 'true' || hasRenderedSuccess) {
      setFormSignedUp(form);
    } else {
      resetForm(form);
    }
  };

  const initializeForms = (root = document) => {
    root.querySelectorAll('[data-back-in-stock-form]').forEach(initializeForm);
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-back-in-stock-form]');
    if (!form) return;

    if (form.dataset.signedUp === 'true') {
      event.preventDefault();
      return;
    }

    const submitButton = form.querySelector('[data-back-in-stock-submit]');
    const submitText = form.querySelector('[data-back-in-stock-submit-text]');

    form.classList.add('is-submitting');
    if (submitButton) submitButton.disabled = true;
    if (submitText) submitText.textContent = form.dataset.submittingText;
  });

  document.addEventListener('DOMContentLoaded', () => initializeForms());
  document.addEventListener('shopify:section:load', (event) => initializeForms(event.target));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      initializeForms(document.getElementById(`ProductBackInStockForm-${data.sectionId}`) || document);
    });
  }
})();
